<template>
    <div class="mt-8 flex flex-col items-center justify-center gap-6 sm:flex-row sm:justify-between">
        <LangSwitch />
        <FleequidCustomerServiceContact />
    </div>
</template>
